module.exports = __webpack_public_path__ + "static/media/icon-housing.8ef011da.png";